import { render, staticRenderFns } from "./TicketsTypeView.vue?vue&type=template&id=58f655c2&scoped=true"
import script from "./TicketsTypeView.vue?vue&type=script&lang=js"
export * from "./TicketsTypeView.vue?vue&type=script&lang=js"
import style0 from "./TicketsTypeView.vue?vue&type=style&index=0&id=58f655c2&prod&lang=scss&scoped=true"
import style1 from "./TicketsTypeView.vue?vue&type=style&index=1&id=58f655c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f655c2",
  null
  
)

export default component.exports